import React, { useState } from "react";
import { Mail, Phone } from "lucide-react";
import { useToast } from "../hooks/use-toast";
import { contactInfo } from "../mock";

const Contact = () => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", company: "", email: "", desc: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.desc) {
      toast({ title: "Completări necesare", description: "Te rugăm să completezi numele, emailul și descrierea." });
      return;
    }
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      toast({ title: "Mesaj trimis!", description: "Mulțumim, țiți vom răspunde în cel mai scurt timp." });
      setForm({ name: "", company: "", email: "", desc: "" });
    }, 800);
  };

  return (
    <section id="contact" className="section-pad bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <h2 className="font-serif-display text-[#0e0e0f]" style={{ fontSize: "clamp(2rem, 4.4vw, 3.75rem)" }}>
            Hai să Construim Ceva Extraordinar
          </h2>
          <p className="mt-4 text-neutral-500 text-[17px]">
            Spune-ne viziunea ta. Te ajutăm să o transformi în realitate.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="mt-14 space-y-6">
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm text-neutral-700 mb-2">Numele tău</label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                type="text"
                placeholder="Ex: Ion Popescu"
                className="form-input w-full border border-neutral-200 rounded-xl px-5 py-4 bg-white text-[15px] placeholder:text-neutral-400"
              />
            </div>
            <div>
              <label className="block text-sm text-neutral-700 mb-2">Companie</label>
              <input
                name="company"
                value={form.company}
                onChange={handleChange}
                type="text"
                placeholder="Ex: Studio SRL"
                className="form-input w-full border border-neutral-200 rounded-xl px-5 py-4 bg-white text-[15px] placeholder:text-neutral-400"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm text-neutral-700 mb-2">Adresă Email</label>
            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              type="email"
              placeholder="nume@exemplu.ro"
              className="form-input w-full border border-neutral-200 rounded-xl px-5 py-4 bg-white text-[15px] placeholder:text-neutral-400"
            />
          </div>

          <div>
            <label className="block text-sm text-neutral-700 mb-2">Descrierea Proiectului</label>
            <textarea
              name="desc"
              value={form.desc}
              onChange={handleChange}
              rows={5}
              placeholder="Spune-ne despre proiectul tău..."
              className="form-input w-full border border-neutral-200 rounded-xl px-5 py-4 bg-white text-[15px] placeholder:text-neutral-400 resize-none"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-[#0e0e0f] text-white py-5 rounded-xl font-semibold tracking-wide text-[15px] hover:bg-[#1e1e22] transition-colors duration-200 disabled:opacity-70"
          >
            {submitting ? "SE TRIMITE..." : "TRIMITE MESAJUL"}
          </button>
        </form>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-x-8 gap-y-3 text-neutral-500">
          <div className="flex items-center gap-2">
            <Mail size={16} />
            <span className="text-sm">Scrie-ne la</span>
            <a href={`mailto:${contactInfo.email}`} className="text-[#0e0e0f] underline text-sm">
              {contactInfo.email}
            </a>
          </div>
          <div className="hidden sm:block w-px h-4 bg-neutral-300" />
          <div className="flex items-center gap-2">
            <Phone size={16} />
            <span className="text-sm">Telefon</span>
            <a href={`tel:${contactInfo.phone.replace(/\s/g, "")}`} className="text-[#0e0e0f] underline text-sm">
              {contactInfo.phone}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
